import React, {FC, ReactNode} from 'react';
import LoadingAnimation from "./LoadingAnimation";

export interface LoadingHandlerProps {
    isLoading: boolean
    children: React.ReactNode | React.ReactNode[]
    variant?: "overlay" | "small"
}


/**
 * LoadingHandler
 *
 * display loading indicator, when isLoading property is true, else displays the children
 *
 * @param isLoading
 * @param children
 *
 * @constructor
 */
export function LoadingHandler({ isLoading, children, variant }: LoadingHandlerProps ) {

    const loadingComp = variant === "small"
        ? <div>
            <div className='loader-small' />
            { children }
        </div>
        : <LoadingAnimation children={ children }  />

    return (
        <div>
            { isLoading
              ? loadingComp
              : children
            }
        </div>
    );
}